import { productDetails } from '../../../shared/utils/product-details-helpers';
import { TFunction } from 'i18next';
import { InputDropdownOptions } from '../../../shared/LCFormFieldInputDropdown';

export const mapAgeGroup = (
    ageGroup: string | undefined,
    currentAgeCategory: string | undefined,
    t: TFunction
): InputDropdownOptions<string> => {
    const ageGroupData = productDetails.getAgeGroups(currentAgeCategory);

    let current: string | undefined = undefined;
    if (ageGroup && ageGroupData.indexOf(ageGroup) >= 0) {
        current = ageGroup;
    } else if (currentAgeCategory) {
        current = 'All';
    }

    return {
        current,
        all: ageGroupData.map(ageGroup => ({
            key: ageGroup,
            value: t(`yourLocalContent.yourTitles.dropdowns.ageGroup.${ageGroup}`, ageGroup)
        }))
    };
};
